import {combineReducers} from 'redux'
import navigation from "./navigation.js";
import userData from './userData.js';
import vaView from './vaView';

export default combineReducers({
    navigation,
    userData,
    vaView
}) 